import axios from "axios";
import { useState, useRef } from "react";
import _axios from "../../../httpService";
import { toast } from "react-toastify";

const DeleteLevelForm = () => {
  const [accountList, setAccountList] = useState([]);
  function typeAccountHandler(e) {
    let value = e.target.value;
    axios({
      method: "get",
      url: `${localStorage.getItem("apiUrl2")}w/cld/`,
      params: { level: value },
      headers: { Authorization: `Bearer ${localStorage.getItem("token")}` },
    }).then((response) => {
      setAccountList(response.data);
    });
  }

  const typeRef = useRef();
  const accountRef = useRef();

  const deleteHandler = (e) => {
    e.preventDefault();
    // const level = typeRef.current.value;
    const account = accountRef.current.value;
    const data = { key: account };
    _axios
      .post(`${localStorage.getItem("apiUrl2")}z/dm/`, data)
      .then((response) => {
        toast.success(response.data.message);
      });
  };
  return (
    <>
      <form className="formChanges">
        <div className="title-template">
          <div className="line"></div>
          <div className="lable-box-title-new">
            <label className="headLabel">فرم سطح</label>
          </div>
        </div>
        {/*  نوع حساب و فیلد شاخص*/}
        <div className="selectBox">
          <div className="selectBox-sides">
            <label htmlFor="accountType" className="control-lable form-label">
              نوع حساب
            </label>
            <select
              defaultValue={"nullSelect"}
              className="inputBox"
              id="accountType"
              onChange={typeAccountHandler}
              ref={typeRef}
            >
              <option value={"nullSelect"} hidden={true}>
                گزینه مورد نظر خود را انتخاب کنید
              </option>
              <option value="1">گروه</option>
              <option value="2">کل</option>
              <option value="3">معین</option>
            </select>
          </div>
          <div className="selectBox-sides">
            <label
              htmlFor="topLevelAccount"
              className="control-lable form-label"
            >
              لیست حساب ها
            </label>
            <select
              className="inputBox"
              id="topLevelAccount"
              defaultValue="nullSelect"
              ref={accountRef}
            >
              <option value={"nullSelect"} hidden={true}>
                گزینه مورد نظر خود را انتخاب کنید
              </option>
              {accountList.map((v) => (
                <option value={v.key} key={v.key}>
                  {v.name}
                </option>
              ))}
            </select>
          </div>
        </div>

        <div className="button-box mx-auto my-3 twoBtn ">
          <button
            type="submit"
            className=" btn-confirm"
            onClick={deleteHandler}
          >
            ثبت
          </button>
        </div>
      </form>
    </>
  );
};
export default DeleteLevelForm;
